import { Action } from '@ngrx/store';
import { Device } from '@codegen';

export enum UserProfileTypes {
  GetActiveDevices = '[UserProfile] Get active devices',
  SetActiveDevices = '[UserProfile] Set active devices',
  DeleteCurrentDevice = '[UserProfile] Delete current device',
  DeleteAllDevicesExceptCurrent = '[UserProfile] Delete all devices except current',
}

export class GetActiveDevices implements Action {
  public readonly type = UserProfileTypes.GetActiveDevices;
}

export class SetActiveDevices implements Action {
  public readonly type = UserProfileTypes.SetActiveDevices;
  constructor(public payload: Device[] | undefined) {}
}

export class DeleteCurrentDevice implements Action {
  public readonly type = UserProfileTypes.DeleteCurrentDevice;
  constructor(public payload: string) {}
}

export class DeleteAllDevicesExceptCurrent implements Action {
  public readonly type = UserProfileTypes.DeleteAllDevicesExceptCurrent;
}

export type UserProfileActions =
  | GetActiveDevices
  | SetActiveDevices
  | DeleteCurrentDevice
  | DeleteAllDevicesExceptCurrent;
